import { getUserLocale } from 'get-user-locale';

export const formatCurrency = (amount: number, currency: string, decimal: boolean = true): string => {
    let decAmount = 0.0;
    if (amount !== 0 && !isNaN(amount)) {
        decAmount = amount / 100.0;
    }
    const locale = getUserLocale({ fallbackLocale: "en-US", useFallbackLocale: true });
    let options: Intl.NumberFormatOptions = {
        style: "currency",
        currency: currency.toUpperCase()
    };
    if (!decimal) {
        options.minimumFractionDigits = 0;
        options.maximumFractionDigits = 0
    }
    return new Intl.NumberFormat(locale, options)
        .format(decAmount);
}

